import { getOrgIdForCaseNotes } from '../../pages/Cases/CaseDetails/CaseNotes/CaseNote.helpers'

// Introducers belong to the case owner's (AR) organisation, so any dropdown that reconciles
// a case's introducer_id against a fetched introducer list must scope that list to the case's
// org — never the acting user's. A DA reviewing an AR-owned case otherwise gets its own firm's
// list, nothing matches the case's introducer, and the dropdowns silently render blank.
export const getIntroducerListOrgId = (details: Maybe<Case>, actingUserOrgId: Maybe<string>): string =>
  getOrgIdForCaseNotes(details) || actingUserOrgId || ''
